import { ethers } from 'ethers';
import MedVaultABI from '../contracts/MedVaultABI.json';

// Your latest deployed contract address on BlockDAG IDE
export const CONTRACT_ADDRESS = '0x0DF55896BcD0d0654A7947dfd8a018c272668A0A';

export function getContract(signerOrProvider) {
  if (!signerOrProvider) {
    throw new Error('Provider or signer required');
  }
  return new ethers.Contract(CONTRACT_ADDRESS, MedVaultABI, signerOrProvider);
}

export function isValidAddress(address) {
  return ethers.isAddress(address);
}
